/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module LicensingModule
 */

const moduleName = 'licensing';
const componentName = 'connect-on-prem-modal';
const prefix = `${moduleName}.${componentName}`;

export const modalTitle = `${prefix}.modalTitle`;
export const deployRegisterStepTitle = `${prefix}.deployRegisterStepTitle`;
export const deployRegisterStepDescription = `${prefix}.deployRegisterStepDescription`;
export const deployingLicenseHubKbLinkLabel = `${prefix}.deployingLicenseHubKbLinkLabel`;
export const registerLicenseHubDescription = `${prefix}.registerLicenseHubDescription`;
export const registeringLicenseHubKbLinkLabel = `${prefix}.registeringLicenseHubKbLinkLabel`;
export const licensesStepTitle = `${prefix}.licensesStepTitle`;
export const viewLicensesManageDescription = `${prefix}.viewLicensesManageDescription`;
export const pulseLicensesLinkLabel = `${prefix}.pulseLicensesLinkLabel`;
export const manageLicenseDescription = `${prefix}.manageLicenseDescription`;
export const broadcomEntitlementsLinkLabel = `${prefix}.broadcomEntitlementsLinkLabel`;
export const endpointManagementStepTitle = `${prefix}.endpointManagementStepTitle`;
export const endpointManagementStepDescription = `${prefix}.endpointManagementStepDescription`;
export const endpointManagementKbLinkLabel = `${prefix}.endpointManagementKbLinkLabel`;
export const usageReportingStepTitle = `${prefix}.usageReportingStepTitle`;
export const usageReportingStepDescription = `${prefix}.usageReportingStepDescription`;
export const usageReportingKbLinkLabel = `${prefix}.usageReportingKbLinkLabel`;
export const closeButtonLabel = `${prefix}.closeButtonLabel`;

export const ENGLISH = {
    [modalTitle]: 'Connect to On-prem License Hub',
    [deployRegisterStepTitle]: 'Deploy & Register',
    [deployRegisterStepDescription]: 'Deploy License Hub to get started with on-prem licensing.',
    [deployingLicenseHubKbLinkLabel]: 'Deploying License Hub KB',
    [registerLicenseHubDescription]: 'Register your License Hub (Connected/Disconnected Mode) to VMware Avi Cloud Console.',
    [registeringLicenseHubKbLinkLabel]: 'Registering License Hub KB',
    [licensesStepTitle]: 'Licenses',
    [viewLicensesManageDescription]: 'View licenses and manage assignments in VMware Avi Cloud Console.',
    [pulseLicensesLinkLabel]: 'VMware Avi Cloud Console | Licenses',
    [manageLicenseDescription]: 'To split, merge, or upgrade licenses in Support Portal.',
    [broadcomEntitlementsLinkLabel]: 'Broadcom Support Portal | Entitlements',
    [endpointManagementStepTitle]: 'Endpoint Management',
    [endpointManagementStepDescription]: 'Assign licenses to AVI Controllers from On-prem License Hub.',
    [endpointManagementKbLinkLabel]: 'Endpoint Management KB',
    [usageReportingStepTitle]: 'Usage Reporting and License Refresh',
    [usageReportingStepDescription]: 'License usage needs to be reported to VMware Avi Cloud Console on a regular basis for license refresh.',
    [usageReportingKbLinkLabel]: 'Usage Reporting KB',
    [closeButtonLabel]: 'CLOSE',
};
